<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 23 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.4812 9.69357H21.8305V6.55345C21.8305 6.53373 21.8274 6.51416 21.8248 6.49414C21.8237 6.36959 21.7841 6.24701 21.6987 6.15013L16.4737 0.181741C16.4721 0.180061 16.4705 0.179566 16.4695 0.178034C16.4384 0.14309 16.4021 0.114175 16.3636 0.0892642C16.3522 0.0815042 16.3408 0.0751282 16.3289 0.0685545C16.2956 0.0505138 16.2603 0.0353399 16.224 0.0244167C16.2142 0.0218465 16.2054 0.0177935 16.1955 0.0151245C16.156 0.00583232 16.115 0 16.0736 0H3.23235C2.64595 0 2.16963 0.476916 2.16963 1.06277V9.69327H1.51903C0.680159 9.69327 0 10.3732 0 11.2121V19.111C0 19.9496 0.680159 20.6302 1.51903 20.6302H2.16963V26.0374C2.16963 26.6233 2.64595 27.1001 3.23235 27.1001H20.7677C21.3536 27.1001 21.8305 26.6233 21.8305 26.0374V20.6302H22.4812C23.3197 20.6302 24 19.9499 24 19.1113V11.2124C24 10.3732 23.3197 9.69357 22.4812 9.69357ZM3.23235 1.06277H15.5422V6.49997C15.5422 6.79357 15.7803 7.03136 16.0736 7.03136H20.7677V9.69352H3.23235V1.06277ZM11.2326 15.4794C9.91388 15.0202 9.0547 14.2905 9.0547 13.1371C9.0547 11.7826 10.1846 10.7464 12.0565 10.7464C12.9515 10.7464 13.6108 10.9348 14.0814 11.1471L13.6816 12.5953C13.3637 12.4418 12.7987 12.2181 12.0213 12.2181C11.2445 12.2181 10.8678 12.5715 10.8678 12.9835C10.8678 13.49 11.3149 13.7135 12.3397 14.1021C13.7405 14.62 14.3998 15.3496 14.3998 16.4684C14.3998 17.7984 13.3757 18.9291 11.1974 18.9291C10.291 18.9291 9.39584 18.693 8.94863 18.4462L9.31339 16.9626C9.79639 17.2104 10.5379 17.4572 11.3035 17.4572C12.1275 17.4572 12.5633 17.1157 12.5633 16.5974C12.563 16.1026 12.1861 15.8203 11.2326 15.4794ZM1.88384 14.961C1.88384 12.2534 3.81514 10.7464 6.21628 10.7464C7.14658 10.7464 7.85294 10.9348 8.17105 11.0998L7.80569 12.5241C7.44092 12.3716 6.9342 12.2305 6.29862 12.2305C4.87405 12.2305 3.76769 13.0893 3.76769 14.855C3.76769 16.4445 4.70931 17.445 6.31098 17.445C6.85205 17.445 7.45258 17.3274 7.80569 17.1861L8.07669 18.5871C7.74692 18.7522 7.00542 18.9291 6.03992 18.9291C3.29675 18.9291 1.88384 17.2214 1.88384 14.961ZM20.7677 25.7493H3.23235V20.6302H20.7677V25.7493ZM19.5807 18.8109H17.4851L14.9421 10.8761H16.9086L17.8737 14.2319C18.1445 15.1733 18.3917 16.0798 18.5805 17.0688H18.6155C18.8156 16.115 19.0626 15.1732 19.3335 14.2667L20.3461 10.8761H22.2539L19.5807 18.8109Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCsv',
  props: {
    fill: {
      type: String,
      default: 'white',
    },
    width: {
      type: Number,
      default: 23,
    },
    height: {
      type: Number,
      default: 27,
    },
  },
};
</script>

<style scoped>
</style>